export default {
  translation: {
    "app": {
      "title": "Matrix Чат"
    },
    "login": {
      "title": "Вход.",
      "username": "Логин",
      "password": "Пароль",
      "loginButton": "Войти",
      "usernameRequired": "Введите логин",
      "passwordRequired": "Введите пароль",
      "invalidCredentials": "Неверное имя пользователя или пароль",
      "loginError": "Ошибка входа: {{error}}",
      "loginFailed": "Не удалось войти. Пожалуйста, попробуйте снова."
    },
    "header": {
      "logout": "Выйти",
      "userManagement": "Управление пользователями",
      "reconnect": "Переподключиться"
    },
    "chat": {
      "selectRoom": "Выберите комнату для начала общения",
      "loading": "Загрузка комнат...",
      "connectionLost": "Соединение потеряно",
      "reconnecting": "Переподключение...",
      "connected": "Подключено",
      "disconnected": "Отключено",
      "reconnectButton": "Переподключиться",
      "onlineMembersCount": "{{count}} онлайн",
      "typing": "{{user}} печатает...",
      "reply": "Ответить",
      "edit": "Редактировать",
      "delete": "Удалить",
      "cancel": "Отмена",
      "save": "Сохранить",
      "messageInput": "Введите сообщение...",
      "uploadFile": "Загрузить файл",
      "sendMessage": "Отправить сообщение",
      "editMessage": "Редактировать сообщение",
      "replyTo": "Напишите ваш ответ...",
      "editingMessage": "Редактирование сообщения",
      "edited": "Отредактировано",
      "earlier": "ранее",
      "addReaction": "Добавить реакцию",
      "messageActions": "Действия c сообщением",  
      "deleteMessage": "Удалить сообщение",
      "deleteMessageConfirm": "Вы уверены, что хотите удалить это сообщение? Это действие нельзя отменить.",
      "deletedMessage": "Это сообщение было удалено"
    },
    "notifications": {
      "newMessage": "Новое сообщение",
      "connectionProblem": "Проблемы с подключением. Повторная попытка через {{seconds}} сек.",
      "serverUnavailable": "Сервер недоступен. Повторите попытку позже.",
      "alreadyConnecting": "Уже выполняется подключение, пожалуйста подождите",
      "tooFrequentAttempts": "Подождите, слишком частые попытки ({{seconds}}с)",
      "sessionExpired": "Ваша сессия истекла. Пожалуйста, войдите снова."
    },
    "members": {
      "online": "Онлайн",
      "offline": "Оффлайн",
      "unavailable": "Отошёл",
      "unknown": "Неизвестно",
      "members": "Участники",
      "justNow": "только что",
      "minutes": "мин назад",
      "hours": "ч назад",
      "days": "дн назад",
      "connections": "соединений",
      "moderator": "Модератор",
      "lastActivity": "Последняя активность",
      "support": "Поддержка",
      "loadingRoomMembers": "Загрузка участников комнаты {{roomId}}...",
      "selectRoomForMembers": "Выберите комнату для просмотра участников",
      "myTeam": "Моя команда",
      "noMembers": "Нет участников",
      "updated": "Обновлено",
      "updatedAuto": "авто"
    },
    "language": {
      "english": "English",
      "russian": "Русский",
      "ukrainian": "Українська"
    },
    "fileAttachment": {
      "attachments": "Вложения",
      "unknown": "Неизвестный файл",
      "unknownSize": "Неизвестный размер",
      "download": "Скачать",
      "view": "Просмотр",
      "dropFileHere": "Перетягните файл сюда",
      "uploadFiles": "Загрузить файлы",
      "clickOrDragFiles": "Кликните или перетащите файлы в эту область для загрузки"
    },
    "emojiPicker": {
      "title": "Выберите эмодзи",
      "description": "Выберите эмодзи для отправления",
      "search": "Поиск",
      "addReaction": "Нажмите для добавления",
      "removeReaction": "Нажмите для удаления"
    },
    "messageList": {
      "loading": "Загрузка сообщений...",
      "loadMore": "Загрузить предыдущие сообщения",
      "loadMoreDeep": "Загрузить более старые сообщения",
      "reachedStartOfHistory": "Достигнуто начало истории сообщений"
    },
    "notificationSettings": {
      "title": "Настройки уведомлений",
      "soundNotifications": "Звуковые уведомления",
      "close": "Закрыть",
      "enableSound": "Включить звук",
      "disableSound": "Отключить звук",
      "listen": "Прослушать",
      "soundSelection": "Выбор звука уведомления"
    },
    "roomsList": {
      "noMessages": "Нет сообщений",
      "emptyMessage": "Пустое сообщение",
      "chatRooms": "Комнаты"
    },
    "serviceMessage": {
      "join": "теперь с нами",
      "leave": "покинул",
      "restricted": "только для"
    },
    "userManagement": {
      "noWebSocketConnection": "Нет соединения с WebSocket",
      "userAdded": "Пользователь {{username}} успешно добавлен",
      "userUpdated": "Пользователь {{username}} успешно обновлен",
      "userDeleted": "Пользователь {{username}} успешно удален",
      "confirmDeletion": "Подтверждение удаления",
      "confirmDeletionContent": "Вы уверены, что хотите удалить пользователя \"{{username}}\"?",
      "username": "Имя пользователя",
      "created": "Создан",
      "actions": "Действия",
      "noPermission": "У вас нет разрешения на управление пользователями",
      "userManagement": "Управление пользователями",
      "addUser": "Добавить пользователя",
      "addNewUser": "Добавить нового пользователя",
      "usernameRequired": "Введите имя пользователя",
      "password": "Пароль",
      "passwordRequired": "Введите пароль",
      "cancel": "Отмена",
      "changePassword": "Изменить пароль для {{username}}", 
      "newPassword": "Новый пароль",
      "updatePassword": "Обновить пароль",
      "newPasswordRequired": "Введите новый пароль",
      "userNotSelected": "Пользователь не выбран",
      "deletingUser": "Удаление пользователя...",
      "editPassword": "Изменить пароль для {{username}}",
      "deleteUser": "Удалить пользователя {{username}}",
      "searchUsername": "Поиск по имени пользователя",
      "updateList": "Обновить список",
      "noData": "Нет данных",
      "delete": "Удалить",
      "attention": "Внимание",
      "ifUserIsAuthorized": "Если пользователь в данный момент авторизован, его сессия будет принудительно завершена."

    },
    "search": {
      "title": "Поиск сообщений",
      "placeholder": "Поиск в этой комнате...",
      "button": "Найти",
      "searching": "Поиск...",
      "resultsFound": "Найдено результатов: {{count}}",
      "noResults": "Ничего не найдено",
      "tryDifferent": "Попробуйте другой поисковый запрос",
      "startSearching": "Введите поисковый запрос для поиска сообщений",
      "newestFirst": "Сначала новые",
      "oldestFirst": "Сначала старые",
      "sortNewestFirst": "Сортировка: сначала новые",
      "sortOldestFirst": "Сортировка: сначала старые",
      "tip": "Подсказка: Поиск не чувствителен к регистру",
      "total": "Всего"
    },
    "common": {
      "more": "еще"
    },
    "message": {
      "edited": "изменено"
    }
  }
};
